const database = [
    { 
        id: 3, 
        anchorlink: '#3',
        title: 'イラストを新規で作成してもらいました',
        category: 'ブログ記事',
        content: '今回、スキルマーケット『coconara』という依頼サイトを利用して、SNSやプロフィール画像に利用できる似顔絵イラストを描いていただきました。イラスト入るとなんか親近感湧いていいですね。',
        image1: require("@/assets/img/news/200222_1138.jpg"),
        caption: 'https://coconala.com/',
        datetime: '2020年2月22日',
    },
    { 
        id: 2, 
        anchorlink: '#2',
        title: 'Newsページ新設しました！',
        category: 'ブログ記事',
        content: '今後は案内やイベントなどアクテビティなど発信する場所と利用していきます。',
        image1: '',
        caption: '',
        datetime: '2020年2月16日',
    },
    { 
        id: 1,
        anchorlink: '#1',
        title: 'ポートフォリオ&制作依頼ページ、リリースしました！',
        category: 'ブログ記事',
        content: 'ポートフォリオ&制作依頼ページ、リリースしました！プロフィールやスキル、制作実績・個人制作物など紹介しています。お問い合わせフォームからデザイン・サイト制作のご依頼など随時受付中ですのでお気軽にご相談ください。',
        image1: require("@/assets/img/news/200215_2330.png"),
        caption: '',
        datetime: '2020年2月15日',
    },
]

export default {
    fetch(id) { return database },
    find(id) { return database.find(el => el.id === id) },
    asyncFind(id, callback) {
        setTimeout(() => {
            callback(database.find(el => el.id === id))
        }, 100)
    }
}


// WEBPACK FOOTER //
// ./src/api/news.js